import { Injectable } from '@angular/core';
import BaseService from '../base/base-service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SessionStorageService } from './session-storage.service';
import { YeminusApis } from '@cf-v5-workspace/enums';
import ResponseModel from '@cf-v5-workspace/utils/models/response.model';
import VisorAgendaModel from '../models/visor-agenda.model';


@Injectable({
	providedIn: 'root'
})
export class AgendaService extends BaseService {

	static listadoPreguntas: any[];

	constructor(public http: HttpClient, sessionStorage: SessionStorageService) {
		super(http, sessionStorage);
	}

	/**
	 * Método que se encarga de obtener la informacion de la cita medica
	 * @author Bvelez
	 */
	obtenerInformacionCita(id: number):Observable<ResponseModel<VisorAgendaModel>> {
		return this.consumeApiService('api/actividades/obtenerActividadVisorAgenda', {id}, YeminusApis.GestionTrabajo);
	}

}
